import type { ModuleWithProviders } from '@angular/core';
import { NgModule } from '@angular/core';

import type { WysiwygUploaderProvider } from './redactor/extensions/upload/upload.types';
import { NoopWysiwygUploader, WysiwygUploader } from './redactor/extensions/upload/upload.types';
import { RedactorModule } from './redactor/redactor.module';
import type { WysiwygDataProvider } from './wysiwyg-extensions/adapter/wysiwyg-adapter.types';
import { NoopWysiwygData, WysiwygData } from './wysiwyg-extensions/adapter/wysiwyg-adapter.types';
import { WysiwygPlaceholderModule } from './wysiwyg-extensions/placeholders/wysiwyg-placeholder.module';

@NgModule({
  imports: [WysiwygPlaceholderModule, RedactorModule],
  exports: [WysiwygPlaceholderModule, RedactorModule],
})
export class RtWysiwygModule {
  public static forRoot(
    uploaderProvider?: WysiwygUploaderProvider,
    dataProvider?: WysiwygDataProvider,
  ): ModuleWithProviders<RtWysiwygModule> {
    return {
      ngModule: RtWysiwygModule,
      providers: [
        uploaderProvider
          ? uploaderProvider
          : {
              provide: WysiwygUploader,
              useClass: NoopWysiwygUploader,
            },
        dataProvider
          ? dataProvider
          : {
              provide: WysiwygData,
              useClass: NoopWysiwygData,
            },
      ],
    };
  }
}

export * from './wysiwyg-extensions/link/wysiwyg-link.types';
export * from './wysiwyg-extensions/adapter/wysiwyg-adapter.types';
